(function() {

    'use strict';

    angular.module('Filters')
    
    .filter('firstUpper', function() {
	    return function(input, scope) {
	        return input ? input.substring(0,1).toUpperCase()+input.substring(1).toLowerCase() : "";
	    }
	});

})();


// WEBPACK FOOTER //
// ./js/filters/global.js